import { render } from "./voteEnd.vue?vue&type=template&id=f752e822&scoped=true"
import script from "./voteEnd.vue?vue&type=script&lang=js"
export * from "./voteEnd.vue?vue&type=script&lang=js"

import "./voteEnd.vue?vue&type=style&index=0&id=f752e822&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f752e822"]])

export default __exports__